const getSelectedViewByStatus = (monitoringStatus) => {
  const status = monitoringStatus?.status;

  switch (status) {
    case 'CLOCKED_IN_ACTIVE':
      return 'clock-in';
    case 'ON_BREAK':
      return 'break';
    case 'CLOCKED_OUT':
    case 'NOT_CLOCKED_IN':
    default:
      return 'presence';
  }
};

export default getSelectedViewByStatus;
